import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import ReactDOM from 'react-dom';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { consumeTheme } from '../../utils/theme';
import { decideKeepDom } from '../../utils/keepDom';
import { emptyFn } from '../../utils/helper';
import Button from '../Button';
export var TIP_TRANSITION_DURATION = 200;
var SCROLL_TRIGGER_LENGTH = 8;
var Tip = (function (_super) {
    __extends(Tip, _super);
    function Tip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prevTouchScreenY = 0;
        _this.state = {
            selfVisible: true,
        };
        _this.handleTouchStart = function (e) {
            if (!_this.props.visible) {
                return;
            }
            var touch = e.touches.item(0);
            if (!touch) {
                return;
            }
            _this.prevTouchScreenY = touch.screenY;
        };
        _this.handleTouchMove = function (e) {
            if (!_this.props.visible) {
                return;
            }
            var touch = e.touches.item(0);
            if (!touch) {
                return;
            }
            if (_this.prevTouchScreenY - touch.screenY > SCROLL_TRIGGER_LENGTH) {
                return _this.setState({ selfVisible: false });
            }
            if (_this.prevTouchScreenY - touch.screenY < -SCROLL_TRIGGER_LENGTH) {
                return _this.setState({ selfVisible: true });
            }
            _this.prevTouchScreenY = touch.screenY;
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, zIndex = _b.zIndex, title = _b.title, description = _b.description, action = _b.action, icon = _b.icon, onClickAction = _b.onClickAction, actionType = _b.actionType, children = _b.children, rootDomRef = _b.rootDomRef, onClose = _b.onClose;
            var visible = _this.renderVisible;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-narrow"] = !icon && !description && !children,
                _a[prefixCls + "-hidden"] = !visible,
                _a));
            if (!decideKeepDom.call(_this, TIP_TRANSITION_DURATION, _this.props.visible)) {
                return null;
            }
            return ReactDOM.createPortal(h("div", { className: classes, style: __assign({ zIndex: zIndex }, style), ref: rootDomRef },
                icon &&
                    h("div", { className: classNames(prefixCls + "-icon"), style: typeof icon === 'string' ? { backgroundImage: "url(\"" + icon + "\")" } : undefined }, React.isValidElement(icon) && icon),
                h("div", { className: classNames(prefixCls + "-text") },
                    title && h("div", { className: classNames(prefixCls + "-text-title") }, title),
                    description && h("div", { className: classNames(prefixCls + "-text-desc") }, description)),
                action &&
                    h("div", { className: classNames(prefixCls + "-action"), onClick: onClickAction }, React.isValidElement(action)
                        ? action
                        : h(Button, { type: actionType }, action)),
                children,
                h("div", { className: classNames(prefixCls + "-close"), onClick: onClose })), document.body);
        };
        return _this;
    }
    Tip.getDerivedStateFromProps = function (props, state) {
        if (!props.visible) {
            return { selfVisible: true };
        }
        return null;
    };
    Object.defineProperty(Tip.prototype, "renderVisible", {
        get: function () {
            return this.props.visible && this.state.selfVisible;
        },
        enumerable: false,
        configurable: true
    });
    Tip.prototype.componentDidMount = function () {
        document.addEventListener('touchmove', this.handleTouchMove);
        document.addEventListener('touchstart', this.handleTouchStart);
    };
    Tip.prototype.componentWillUnmount = function () {
        document.removeEventListener('touchmove', this.handleTouchMove);
        document.removeEventListener('touchstart', this.handleTouchStart);
    };
    Tip.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Tip;
}(React.Component));
export default Tip;
Tip.defaultProps = {
    prefixCls: 'dui-m-tip',
    onClose: emptyFn,
    onClickAction: emptyFn,
};
Tip.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    action: PropTypes.node,
    onClickAction: PropTypes.func,
    description: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.node,
    onClose: PropTypes.func,
    visible: PropTypes.bool,
    zIndex: PropTypes.number,
    actionType: PropTypes.string,
    children: PropTypes.node,
    rootDomRef: PropTypes.any,
};
